'use client';

import { cva, type VariantProps } from 'class-variance-authority';
import { forwardRef, type SVGProps } from 'react';

import { Spinner } from '../../primitives/spinner';
import { cn } from '../../utils/cn';

const spinnerVariants = cva('', {
  variants: {
    size: { xs: 'h-3 w-3', sm: 'h-4 w-4', md: 'h-5 w-5', lg: 'h-6 w-6', xl: 'h-8 w-8' },
    tone: { default: 'text-foreground', muted: 'text-muted-foreground', primary: 'text-primary' },
  },
  defaultVariants: { size: 'sm', tone: 'default' },
});

export interface UzSpinnerProps
  extends Omit<SVGProps<SVGSVGElement>, 'children'>, VariantProps<typeof spinnerVariants> {
  /** Visible label rendered inline for screen-reader and visual users. */
  label?: string;
}

export const UzSpinner = forwardRef<SVGSVGElement, UzSpinnerProps>(
  ({ size, tone, label, className, ...rest }, ref) => {
    if (label) {
      return (
        <span className="text-muted-foreground inline-flex items-center gap-2 text-sm">
          <Spinner ref={ref} className={cn(spinnerVariants({ size, tone }), className)} {...rest} />
          {label}
        </span>
      );
    }
    return (
      <Spinner ref={ref} className={cn(spinnerVariants({ size, tone }), className)} {...rest} />
    );
  },
);
UzSpinner.displayName = 'UzSpinner';
